/** @format */

export const randomMinMax = (min, max) => {
  return Math.floor(Math.random() * (max - min)) + min;
};
